export const SLOT_STATUSES = {
  IDLE: 'idle',
  LOADING: 'loading',
  // A refresh in flight over a chart that's already showing, so it stays on screen.
  REFRESHING: 'refreshing',
  ERROR: 'error',
  READY: 'ready',
}

export const KODI_REPORTS_PATH = '/kodi-reports'

// Who sees a pinned chart: only the user who pinned it, them and chosen people, or
// everyone in the org.
export const REPORT_VISIBILITY = { PRIVATE: 'private', SHARED: 'shared', ORG: 'org' }

// The page's tabs: the viewer's own reports and ones shared with them, and every
// report shared with the whole org (read-only).
export const REPORT_TABS = { MINE: 'mine', PUBLIC: 'public' }

// The Kodi page reads this to attach a chart opened from Kodi Reports.
export const REPORT_CHART_QUERY_PARAM = 'chart'

// Kodi Reports keeps its "Pinned by" filter here, as comma-separated user ids, so
// a refresh or a shared link keeps it.
export const PINNED_BY_QUERY_PARAM = 'pinned_by'

// The viewer's last "Pinned by" choice, restored when they arrive without one in
// the URL. Per org and user, so another account on the browser doesn't inherit it.
export const pinnedByStorageKey = (organizationId, userId) =>
  `kodiReports.pinnedBy.${organizationId}.${userId}`

// How often a card re-renders its "Updated …" label and refresh cooldown.
export const CARD_CLOCK_TICK_MS = 30000

// Mirrors kodi's REFRESH_COOLDOWN_SECONDS. Only used when a refused (429) refresh
// doesn't say how long to wait.
export const REFRESH_COOLDOWN_SECONDS = 15 * 60
